import React from 'react';
import classNames from 'classnames';
import { ListingContactType } from 'models/Listing';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl, RESIZED_WIDTH } from 'components/ResolveImage/utils';

import './ListingContactsCardList.styles.scss';

type ListingContactsCardListProps = {
  className?: string;
  listingContacts: Array<ListingContactType>;
};

const ListingContactsCardList: React.FC<ListingContactsCardListProps> = (
  props,
) => {
  const { listingContacts = [], className } = props;

  const classes = classNames('listing-contacts-card-list', className);

  const shownContact = listingContacts[0];

  if (!shownContact || !shownContact.name) return null;

  return (
    <div className={classes}>
      <div className="left-content">
        <ResolveImage
          asAvatar
          shouldLazyLoad={false}
          src={getImgUrl(shownContact.brokerImage?.url, RESIZED_WIDTH[100])}
        />
        <span>{shownContact.name}</span>
        {shownContact.position && <span>{shownContact?.position}</span>}
      </div>
    </div>
  );
};

export default ListingContactsCardList;
